// src/pages/AnalyticProjectPage.js
import { useLocation, useParams, Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import ProjectHeader from '../../components/project/ProjectHeader';
import ProjectAccessInfo from '../../components/project/ProjectAccessInfo';

const AnalyticProjectPage = () => {
  const { projectId } = useParams();
  const { user } = useAuth();
  const { state } = useLocation(); // Получаем project из state
  const project = state?.project;

  // Проверяем, передан ли project
  if (!project) {
    console.warn('Проект не передан. Вернитесь через карточку проекта.');
    return <div className="p-4 text-danger">Данные проекта не найдены. Пожалуйста, вернитесь и выберите проект снова.</div>;
  }

  return (
    <div className="main-content">
      <ProjectHeader project={project} />
      <ProjectAccessInfo project={project} user={user} />

      <div className="mt-4">
        {/* Передаём project дальше */}
        <Link
          to={`/analytics/calls/${projectId}`}
          className="btn btn-primary"
          state={{ project }}
        >
          Аналитика всех звонков по темам
        </Link>

        <Link
          to={`/analytics/operators/${projectId}`}
          className="btn btn-primary"
          state={{ project }}
        >
          Аналитика звонков операторов по темам
        </Link>
      </div>
    </div>
  );
};

export default AnalyticProjectPage;